import { Component, OnInit } from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DialogModel} from '@shared/models/dialog.model';
import {SnackBarService} from '@core/services/snack-bar.service';

@Component({
    standalone: false,
    selector: 'particle-add-sub-account-dialog',
  templateUrl: './add-sub-account-dialog.component.html',
  styleUrls: ['./add-sub-account-dialog.component.scss']
})
export class AddSubAccountDialogComponent implements OnInit, IDialogView {
  inputForm: FormGroup;
  data: DialogModel;
  constructor(private formBuilder: FormBuilder,
              private snackBarService: SnackBarService) {

  }

  ngOnInit() {
    this.inputForm = this.formBuilder.group({
      accountName: [this.data.input.accountName, Validators.required],
      description: [this.data.input.description, Validators.required]
    });
  }
  onOkClicked(): boolean {
    const accountName = this.inputForm.controls['accountName'].value;
    const description = this.inputForm.controls['description'].value;
    if (!this.inputForm.valid) {
      this.snackBarService.showError('Please fill up necessary fields.');
      return false;
    }
    this.data.input.accountName = accountName;
    this.data.input.description = description;
    return true;
  }
}

